import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "./columns";


const IpdVoucherList = ({ voucherSelectedIpd}) => {
   
    const handleGetRowId = (e) => {
        return e?.ipdid
      }

    return (
        <div className="voucher-list col-12 m-auto">
            <div className="datatable w-100">
                <DataGrid
                    checkboxSelection={false}
                    className="datagrid"
                    rows={voucherSelectedIpd && voucherSelectedIpd !== null ? voucherSelectedIpd : []}
                    columns={userColumns}
                    rowsPerPageOptions={[10]}
                    getRowId={handleGetRowId}
                    loading={voucherSelectedIpd?.length > 0 || voucherSelectedIpd === null ? false : true}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={voucherSelectedIpd}
                    pagination
                    pageSize={10}
                    disableColumnMenu={true}
                />
            </div>

        </div>
    );
};

export default IpdVoucherList;